import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Timer to start the fade-out animation after 8 seconds
    const fadeOutTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, 8000); // 8 seconds

    // Timer to completely remove the component after 8.5 seconds
    const removeTimer = setTimeout(() => {
      setIsVisible(false);
    }, 8500); // 8.5 seconds (giving 0.5s for the fade)

    // Cleanup timers
    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`loading-screen ${isFadingOut ? 'fade-out' : ''}`}>
      {/* Make sure your GIF is in the /public folder and named "my1.gif" */}
      <img src="/my1.gif" alt="Loading Bella Ceylon Voyages..." className="loading-gif" />
      
      {/* The new text element for your brand name */}
      <h1 className="loading-text">Bella Ceylon Voyages</h1>
    </div>
  );
};

export default LoadingScreen;